//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.PmiSemanticData.js";
import "../no/ugmath.js";
let d=[[[0,"AreaSize",0,0],[0,"Diameter",0,0],[0,"FirstPoint",0,0],[0,"Index",0,0],[0,"InnerDiameter",0,0],[0,"IsMovable",0,0],[0,"Label",0,0],[0,"Length",0,0],[0,"MovableModifierAngle",0,0],[0,"SecondPoint",0,0],[0,"Type",0,0],[0,"Width",0,0]],[],[]];
SPLM.Annotations.PmiDatumTargetData = class extends SPLM.Annotations.PmiSemanticData{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiDatumTargetData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.PmiDatumTargetData.Types = Object.freeze({
    "None" : "None", "Point" : "Point", "Line" : "Line", "Rectangular" : "Rectangular", "Circular" : "Circular", "Cylindrical" : "Cylindrical", "Spherical" : "Spherical", "Arbitrary" : "Arbitrary"});

export default SPLM;